import React from "react";
// import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header";

import "./Help.css";

import Faqs from "./Faqs";
import HelpPageHeader from "./Hero";
import Layout from "../../components/Layout";

function Help() {
  return (
    <Layout>
      {/* <HelpPageHeader /> */}
      <Faqs />
    </Layout>
  );
}

export default Help;
